import { defineComponent as _defineComponent } from 'vue'
import { PaginatedQuery, ExportListType } from 'ah-api-gateways';
import { outstandingFeesTableFields } from './tableFields/outstandingFeeTableFields';
import { OutstadingFee, feeStatusBadge } from 'ah-api-gateways/models/feesAndCharges/fees';
import { FeeStatus } from 'ah-api-gateways/models/feesAndCharges/fees';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { PropType, computed } from 'vue';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhTradesState } from '../..';
import { useRouter } from 'vue-router/composables';

interface OutstadingFeeEmits extends UseManagedListingEmits<OutstadingFee> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'OutstandingFeesListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: outstandingFeesTableFields }),
  },
  highlight: {
    type: String as PropType<'none' | 'left' | 'right' | 'both'>,
    required: false,
    default: 'right',
  },
  ...defineUseManagedListingProps<OutstadingFee>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const tradeState = useAhTradesState();

const requestManager = useRequestManager();

const router = useRouter();



const managedListing = useManagedListing<OutstadingFee>({
  loadDataRequest(query: PaginatedQuery) {
    return tradeState.services.fees.listOutstandingFees({ ...query });
  },
  downloadDataRequest(type: string, query: { [key: string]: any }) {
    let documentsTitle: string | undefined = undefined;
    if (managedListing.bindings.filter.type === 'PARTNERS') {
      documentsTitle = 'Partners Outstanding Fees';
    }
    return tradeState.services.fees.downloadOutsandingFeesList(query, type as ExportListType, documentsTitle);
  },
  emit,
  props,
  fields: computed(() => computedTableFields.value),
  reqManager: requestManager.manager,
});

const computedTableFields = computed(() => {
  if (managedListing.bindings.filter.type === 'PARTNERS') {
    return props.config.tableFields.filter((column: any) => column.key !== 'clientName');
  }
  return props.config.tableFields;
});

const showReminder = computed(() => {
  return (fee: OutstadingFee) => {
    return [FeeStatus.DUE, FeeStatus.OVERDUE].includes(fee.feeStatus);
  };
});

function onRowClicked(fee: OutstadingFee) {
  if (managedListing.bindings.filter.type === 'PARTNERS') {
    router.push({ path: `partner/${fee.partnerId}`, append: true });
  } else {
    router.push({ path: `client/${fee.clientId}`, append: true });
  }
}

function sendReminder(fee: OutstadingFee) {
  requestManager.manager
    .cancelAndNew(
      `sendReminder-${fee.clientId}`,
      tradeState.services.notification.sentOutstandingFeeReminder(fee.clientId)
    )
    .subscribe(() => tradeState.toast.success('Reminder sent successfully.'));
}

function rowClass(fee?: OutstadingFee) {
  let out = '';
  if (fee?.feeStatus) {
    out += `status-${feeStatusBadge[fee.feeStatus].class} `;
  }
  if ((props.highlight === 'left' || props.highlight === 'both') && fee?.feeStatus === FeeStatus.OVERDUE) {
    out += 'highlight-left ';
  }
  if (props.highlight === 'right' || props.highlight === 'both') {
    out += 'highlight-right ';
  }
  return out;
}

function statusLabel(fee?: OutstadingFee) {
  if (fee?.feeStatus) {
    return feeStatusBadge[fee.feeStatus].label;
  }
}

expose({
  downloadData: managedListing.downloadData,
});

return { __sfc: true,props, tradeState, requestManager, router, emit, managedListing, computedTableFields, showReminder, onRowClicked, sendReminder, rowClass, statusLabel, formatCurrencyValue }
}

})